import { type HostConfig } from '../typedefs/HostConfig';

export const NO_CONTEXT: HostConfig['hostContext'] = {};
